import React, { useState, useEffect } from 'react';
import _get from 'lodash/get';
import { client } from 'cccisd-apollo';
import Loader from 'cccisd-loader';
import Family from './Family';
import familyQuery from './families.graphql';

function TfhCoachDashboard() {
    const [families, setFamilies] = useState(null);
    const [pinnedFamilies, setPinnedFamilies] = useState([]);

    useEffect(() => {
        async function getFamilies() {
            const resp = await client.query({ query: familyQuery, fetchPolicy: 'network-only' });
            const fams = _get(resp, 'data.groups.tfhClassList', []) || [];
            setFamilies(fams);
        }

        getFamilies();
    }, []);

    function getFamilyName(family) {
        const label = _get(family, 'group.label');
        if (label) {
            return label;
        }

        const firstParent = _get(family, 'descendantRoles.parentList.0');
        if (firstParent) {
            return getMemberName(firstParent);
        }

        return 'Family ' + _get(family, 'group.groupId');
    }

    function getMemberName(member) {
        const { user } = member;
        if (!user) {
            return '';
        }

        const { fullName, firstName, lastName, username } = user;
        if (fullName) {
            return fullName;
        }
        if (firstName && lastName) {
            return `${firstName} ${lastName}`;
        }
        if (firstName) {
            return firstName;
        }

        return username;
    }

    function getIsPinned(family) {
        return pinnedFamilies.includes(family.group.groupId);
    }

    function togglePinned(family) {
        const familyGroupId = _get(family, 'group.groupId');

        if (pinnedFamilies.includes(familyGroupId)) {
            setPinnedFamilies(prev => prev.filter(id => id !== familyGroupId));
        } else {
            setPinnedFamilies(prev => [...prev, familyGroupId]);
        }
    }

    if (!families || !Array.isArray(families)) {
        return <Loader loading />;
    }

    return (
        <div>
            {families
                .sort((a, b) => {
                    const isAPinned = getIsPinned(a);
                    const isBPinned = getIsPinned(b);
                    if (isAPinned === isBPinned) {
                        return getFamilyName(a).localeCompare(getFamilyName(b));
                    }

                    if (isAPinned) {
                        return -1;
                    }

                    return 1;
                })
                .map((family, i) => (
                    <Family
                        key={_get(family, 'group.groupId', 'fam' + i)}
                        family={family}
                        familyName={getFamilyName(family)}
                        isPinned={getIsPinned(family)}
                        togglePinned={togglePinned}
                        getMemberName={getMemberName}
                    />
                ))}
        </div>
    );
}

export default TfhCoachDashboard;
